/**
 * Client module UI labels
 * These are default labels that can be overridden per company
 */
export const CLIENT_LABELS = {
  client: "Client",
  clients: "Clients",
  clientName: "Client Name",
  clientAddress: "Client Address",
  createClient: "Create Client",
  editClient: "Edit Client",
  clientDetails: "Client Details",
  addClient: "Add Client",
  selectClient: "Select a saved Client",
  addNewClient: "+ Add New Client",
  clientCreated: "Client created",
  clientUpdated: "Client updated",
  active: "Active",
  completed: "Completed",
  cancelled: "Cancelled",
  all: "All",
  profile: "Profile",
  about: "About",
  contact: "Contact",
  socialMedias: "Social Medias",
  address1: "Address 1",
  address2: "Address 2",
  cityZip: "City / Zip",
  unknownCity: "Unknown City",
  unknownState: "Unknown State",
  // Client Modal Form labels
  searchNewAddress: "Search New Address",
  deleteClientQuestion: "Delete '{name}' ?",
  // Client Edit Page labels
  general: "General",
  linkedInURL: "LinkedIn URL (optional)",
  facebookURL: "Facebook URL (optional)",
  instagramURL: "Instagram URL (optional)",
  websiteURL: "Website URL (optional)",
  // Client Profile Panel labels
  linkedIn: "LinkedIn",
  facebook: "Facebook",
  instagram: "Instagram",
  website: "Website",
  nA: "n/a",
  // Client Drawer labels
  linkedInColon: "LinkedIn:",
  facebookColon: "Facebook:",
  instagramColon: "Instagram:",
  websiteColon: "Website:",
} as const;

export type ClientLabelKey = keyof typeof CLIENT_LABELS;
